module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-home"
  }, [_c('div', {
    staticClass: "p-home__header u-relative u-flex u-flex-fd--column u-fit-v u-bg--white-near u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnDiscoverRestaurant()
      },
      "mouseenter": function($event) {
        _vm._onMouseenterHeader()
      },
      "mouseleave": function($event) {
        _vm._onMouseleaveHeader()
      }
    }
  }, [_c('div', {
    staticClass: "p-home__header__following-text js-header-following-text u-absolute u-pos-tl u-zindex--2",
    class: [_vm._mouse.moved ? 'is-visible' : 'is-hidden']
  }, [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--medium t-text--xxs u-uppercase u-color--brand-gold",
    domProps: {
      "innerHTML": _vm._s(_vm.content.header_label_discover_following)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-fit u-overflow-h"
  }, [_c('div', {
    staticClass: "p-home__header__gallery u-relative u-fit",
    class: [_vm.$root.isLoaderActive ? 'is-inactive' : 'is-active']
  }, _vm._l((_vm.imagesOnHeader), function(item, index) {
    return _c('div', {
      staticClass: "p-home__header__gallery__item u-absolute u-pos-y-center u-overflow-h"
    }, [_c('div', {
      staticClass: "u-absolute u-pos-tl u-fit",
      style: ({
        'transform': 'translateY(' + (_vm.$root.smoothScroll * item.parallaxRatio * -1) + 'px) translateZ(0)'
      })
    }, [_c('img', {
      staticClass: "p-home__header__gallery__item__image u-absolute u-pos-center u-minw--100 u-minh--100",
      attrs: {
        "src": item.image.sizes['500x0'],
        "alt": item.image.caption ? item.image.caption + ' - Four Seasons' : 'Four Seasons',
        "title": item.image.caption ? item.image.caption + ' - Four Seasons' : 'Four Seasons'
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "p-home__header__content u-marg-x-auto u-w6of10 u-w8of10@xxs u-align-center"
  }, [_c('h1', [_c('span', {
    staticClass: "p-home__header__content__title u-color--black-near u-uppercase t-ffamily--domaine t-fweight--medium",
    domProps: {
      "innerHTML": _vm._s(_vm.content.header_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-t-sm u-inline-block u-click-area--xxs u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnDiscoverRestaurant()
      },
      "mouseenter": function($event) {
        _vm._headerCTAIsHovered = true
      },
      "mouseleave": function($event) {
        _vm._headerCTAIsHovered = false
      }
    }
  }, [_c('app-cta', {
    staticClass: "js-header-cta",
    attrs: {
      "label": _vm.content.header_label_discover_restaurants,
      "href": null
    }
  })], 1), _vm._v(" "), _c('app-scroll-object', {
    attrs: {
      "is-parallax": true,
      "parallax-ratio": -0.035,
      "scale": 1
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _vm._m(0)
        
      },
      staticRenderFns: [function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', {
            staticClass: "p-home__header__content__line u-marg-x-auto u-marg-t-lg u-bg--brand-gold"
          })])
        
      }]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-home__restaurants js-restaurants-container u-fit-w u-bg--white"
  }, _vm._l((_vm.restaurants), function(restaurant, index) {
    return _c('div', {
      staticClass: "p-home__restaurants__restaurant-container",
      class: [restaurant.home_has_gray_bg ? 'has-gray-bg' : '']
    }, [(restaurant.home_layout === _vm.$root.CONSTANTS.homeLayouts.R_TL) ? _c('div', {
      staticClass: "p-home__restaurants__restaurant u-marg-x-auto u-flex u-flex-fd--column-reverse@xxs",
      class: ['p-home__restaurants__restaurant--' + restaurant.home_layout]
    }, [_c('div', {
      staticClass: "u-hide@sm u-flex u-flex-ai--start u-w2of10"
    }, [_c('div', {
      staticClass: "p-home__restaurants__restaurant__second-image u-relative u-fit-w u-bg--white-near u-overflow-h"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": 0.05,
        "scale": 1.2,
        "content": {
          image: restaurant.home_small_image,
          title: restaurant.title
        },
        "is-centered": "xy"
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "u-absolute u-pos-tl u-fit"
            }, [(_vm.content.image) ? _c('img', {
              staticClass: "u-absolute u-pos-center u-minw--100 u-minh--100",
              attrs: {
                "src": _vm.content.image.sizes['320x550'],
                "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title,
                "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title
              }
            }) : _vm._e()])
          
        },
        staticRenderFns: []
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__informations u-relative u-flex u-flex-fd--column u-flex-jc--start u-w3of10 u-w5of10@xs u-fit-w@xxs"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": -0.05,
        "auto-scale": false,
        "content": {
          title: restaurant.title_splitted
        }
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('h2', [(_vm.content.title[0]) ? _c('span', {
              staticClass: "u-block t-ffamily--domaine t-fweight--bold t-text--md u-uppercase",
              domProps: {
                "innerHTML": _vm._s(_vm.content.title[0])
              }
            }) : _vm._e(), _vm._v(" "), _c('span', {
              staticClass: "u-block t-ffamily--domaine t-fweight--light t-text--xxl u-uppercase",
              class: [_vm.content.title[0] !== '' ? 'u-marg-t-xxs' : ''],
              domProps: {
                "innerHTML": _vm._s(_vm.content.title[1])
              }
            })])])
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__informations__content"
    }, [_c('p', {
      staticClass: "t-text--xxs-ls u-uppercase t-ffamily--lato t-fweight--regular",
      domProps: {
        "innerHTML": _vm._s(restaurant.food_type)
      }
    }), _vm._v(" "), (restaurant.michelin_stars && restaurant.michelin_stars.trim() !== '') ? _c('p', {
      staticClass: "u-marg-t-md t-text--xxs-ls u-uppercase t-ffamily--lato t-fweight--regular",
      domProps: {
        "innerHTML": _vm._s(restaurant.michelin_stars)
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "u-marg-t-md t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.services_string)
      }
    }), _vm._v(" "), (restaurant.opening_format === _vm.$root.CONSTANTS.openingFormats.ALWAYS) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.label_always_open)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_restaurant_will_be_closed_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_restaurant_will_be_closed)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_reopening_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_reopening)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_restaurant_will_be_closed_from_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_restaurant_will_be_closed_from)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "u-marg-t-xxxl u-marg-t-md@xxs"
    }, [_c('app-cta', {
      attrs: {
        "label": restaurant.home_discover_restaurant,
        "href": _vm.$root.getRestaurantURLFromSlug(restaurant.slug)
      }
    })], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__main-image u-relative u-w5of10 u-fit-w@xxs u-bg--white-near u-overflow-h"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": 0.05,
        "scale": 1.2,
        "content": {
          image: restaurant.home_main_image,
          title: restaurant.title
        },
        "is-centered": "xy"
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "u-absolute u-pos-tl u-fit"
            }, [(_vm.content.image) ? _c('img', {
              staticClass: "u-absolute u-pos-center u-minw--100 u-minh--100",
              attrs: {
                "src": _vm.content.image.sizes['800x900'],
                "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title,
                "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title
              }
            }) : _vm._e()])
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), (restaurant.booking_available && restaurant.the_fork_restaurant_id) ? _c('div', {
      staticClass: "p-home__restaurants__restaurant__book-button u-absolute u-pos-b--0 u-pos-x-center u-w8of10@sm"
    }, [_c('app-button-book', {
      attrs: {
        "the-fork-id": restaurant.the_fork_restaurant_id,
        "label": restaurant.booking_book_a_table
      }
    })], 1) : _vm._e()], 1)]) : (restaurant.home_layout === _vm.$root.CONSTANTS.homeLayouts.L_BC) ? _c('div', {
      staticClass: "p-home__restaurants__restaurant u-marg-x-auto",
      class: ['p-home__restaurants__restaurant--' + restaurant.home_layout]
    }, [_c('div', {
      staticClass: "u-flex u-flex-fd--column@xxs u-fit-w"
    }, [_c('div', {
      staticClass: "p-home__restaurants__restaurant__main-image u-relative u-w5of10 u-fit-w@xxs u-bg--white-near u-overflow-h"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": 0.05,
        "scale": 1.2,
        "content": {
          image: restaurant.home_main_image,
          title: restaurant.title
        },
        "is-centered": "xy"
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "u-absolute u-pos-tl u-fit"
            }, [(_vm.content.image) ? _c('img', {
              staticClass: "u-absolute u-pos-center u-minw--100 u-minh--100",
              attrs: {
                "src": _vm.content.image.sizes['800x900'],
                "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title,
                "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title
              }
            }) : _vm._e()])
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), (restaurant.booking_available && restaurant.the_fork_restaurant_id) ? _c('div', {
      staticClass: "p-home__restaurants__restaurant__book-button u-absolute u-pos-b--0 u-pos-x-center u-w8of10@sm"
    }, [_c('app-button-book', {
      attrs: {
        "the-fork-id": restaurant.the_fork_restaurant_id,
        "label": restaurant.booking_book_a_table
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__informations u-relative u-flex u-flex-fd--column u-flex-jc--start u-w5of10 u-fit-w@xxs"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": -0.05,
        "auto-scale": false,
        "content": {
          title: restaurant.title_splitted
        }
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('h2', [(_vm.content.title[0]) ? _c('span', {
              staticClass: "u-block t-ffamily--domaine t-fweight--bold t-text--md u-uppercase",
              domProps: {
                "innerHTML": _vm._s(_vm.content.title[0])
              }
            }) : _vm._e(), _vm._v(" "), _c('span', {
              staticClass: "u-block t-ffamily--domaine t-fweight--light t-text--xxl u-uppercase",
              class: [_vm.content.title[0] !== '' ? 'u-marg-t-xxs' : ''],
              domProps: {
                "innerHTML": _vm._s(_vm.content.title[1])
              }
            })])])
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__informations__content"
    }, [_c('p', {
      staticClass: "t-text--xxs-ls u-uppercase t-ffamily--lato t-fweight--regular",
      domProps: {
        "innerHTML": _vm._s(restaurant.food_type)
      }
    }), _vm._v(" "), (restaurant.michelin_stars && restaurant.michelin_stars.trim() !== '') ? _c('p', {
      staticClass: "u-marg-t-md t-text--xxs-ls u-uppercase t-ffamily--lato t-fweight--regular",
      domProps: {
        "innerHTML": _vm._s(restaurant.michelin_stars)
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "u-marg-t-md t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.services_string)
      }
    }), _vm._v(" "), (restaurant.opening_format === _vm.$root.CONSTANTS.openingFormats.ALWAYS) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.label_always_open)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_restaurant_will_be_closed_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_restaurant_will_be_closed)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_reopening_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_reopening)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_restaurant_will_be_closed_from_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_restaurant_will_be_closed_from)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "u-marg-t-xxxl u-marg-t-md@xxs"
    }, [_c('app-cta', {
      attrs: {
        "label": restaurant.home_discover_restaurant,
        "href": _vm.$root.getRestaurantURLFromSlug(restaurant.slug)
      }
    })], 1)])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "u-hide@sm u-flex u-fit-w"
    }, [_c('div', {
      staticClass: "u-w5of10"
    }), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__second-image u-relative u-marg-l-vw1of10 u-w3of10 u-bg--white-near u-overflow-h"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": 0.05,
        "scale": 1.2,
        "content": {
          image: restaurant.home_small_image,
          title: restaurant.title
        },
        "is-centered": "xy"
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "u-absolute u-pos-tl u-fit"
            }, [(_vm.content.image) ? _c('img', {
              staticClass: "u-absolute u-pos-center u-minw--100 u-minh--100",
              attrs: {
                "src": _vm.content.image.sizes['480x480'],
                "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title,
                "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title
              }
            }) : _vm._e()])
          
        },
        staticRenderFns: []
      }
    })], 1)])]) : _c('div', {
      staticClass: "p-home__restaurants__restaurant u-marg-x-auto u-flex u-flex-fd--column@xxs",
      class: ['p-home__restaurants__restaurant--' + restaurant.home_layout]
    }, [_c('div', {
      staticClass: "p-home__restaurants__restaurant__main-image u-relative u-w5of10 u-fit-w@xxs u-bg--white-near u-overflow-h"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": 0.05,
        "scale": 1.2,
        "content": {
          image: restaurant.home_main_image,
          title: restaurant.title
        },
        "is-centered": "xy"
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "u-absolute u-pos-tl u-fit"
            }, [(_vm.content.image) ? _c('img', {
              staticClass: "u-absolute u-pos-center u-minw--100 u-minh--100",
              attrs: {
                "src": _vm.content.image.sizes['800x900'],
                "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title,
                "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title
              }
            }) : _vm._e()])
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), (restaurant.booking_available && restaurant.the_fork_restaurant_id) ? _c('div', {
      staticClass: "p-home__restaurants__restaurant__book-button u-absolute u-pos-b--0 u-pos-x-center u-w6of10@lg u-w8of10@sm"
    }, [_c('app-button-book', {
      attrs: {
        "the-fork-id": restaurant.the_fork_restaurant_id,
        "label": restaurant.booking_book_a_table
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__informations u-relative u-flex u-flex-fd--column u-flex-jc--start u-w3of10 u-w5of10@xs u-fit-w@xxs"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": -0.05,
        "auto-scale": false,
        "content": {
          title: restaurant.title_splitted
        }
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('h2', [(_vm.content.title[0]) ? _c('span', {
              staticClass: "u-block t-ffamily--domaine t-fweight--bold t-text--md u-uppercase",
              domProps: {
                "innerHTML": _vm._s(_vm.content.title[0])
              }
            }) : _vm._e(), _vm._v(" "), _c('span', {
              staticClass: "u-block t-ffamily--domaine t-fweight--light t-text--xxl u-uppercase",
              class: [_vm.content.title[0] !== '' ? 'u-marg-t-xxs' : ''],
              domProps: {
                "innerHTML": _vm._s(_vm.content.title[1])
              }
            })])])
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-home__restaurants__restaurant__informations__content"
    }, [_c('p', {
      staticClass: "t-text--xxs-ls u-uppercase t-ffamily--lato t-fweight--regular",
      domProps: {
        "innerHTML": _vm._s(restaurant.food_type)
      }
    }), _vm._v(" "), (restaurant.michelin_stars && restaurant.michelin_stars.trim() !== '') ? _c('p', {
      staticClass: "u-marg-t-md t-text--xxs-ls u-uppercase t-ffamily--lato t-fweight--regular",
      domProps: {
        "innerHTML": _vm._s(restaurant.michelin_stars)
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "u-marg-t-md t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.services_string)
      }
    }), _vm._v(" "), (restaurant.opening_format === _vm.$root.CONSTANTS.openingFormats.ALWAYS) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.label_always_open)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_restaurant_will_be_closed_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_restaurant_will_be_closed)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_reopening_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_reopening)
      }
    }) : _vm._e(), _vm._v(" "), (restaurant.home_restaurant_will_be_closed_from_replaced) ? _c('p', {
      staticClass: "u-marg-t-xxxs t-text--xs t-ffamily--lato t-fstyle--italic u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(restaurant.home_restaurant_will_be_closed_from)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "u-marg-t-xxxl u-marg-t-md@xxs"
    }, [_c('app-cta', {
      attrs: {
        "label": restaurant.home_discover_restaurant,
        "href": _vm.$root.getRestaurantURLFromSlug(restaurant.slug)
      }
    })], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "u-hide@sm u-flex u-flex-ai--end u-w2of10"
    }, [_c('div', {
      staticClass: "p-home__restaurants__restaurant__second-image u-relative u-fit-w u-bg--white-near u-overflow-h"
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": 0.05,
        "scale": 1.2,
        "content": {
          image: restaurant.home_small_image,
          title: restaurant.title
        },
        "is-centered": "xy"
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "u-absolute u-pos-tl u-fit"
            }, [(_vm.content.image) ? _c('img', {
              staticClass: "u-absolute u-pos-center u-minw--100 u-minh--100",
              attrs: {
                "src": _vm.content.image.sizes['480x480'],
                "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title,
                "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + _vm.content.title : _vm.content.title
              }
            }) : _vm._e()])
          
        },
        staticRenderFns: []
      }
    })], 1)])])])
  })), _vm._v(" "), _c('app-page-footer', {
    attrs: {
      "text": _vm.content.footer_text_content,
      "page": _vm.content.footer_page,
      "link-label": _vm.content.footer_label_contact
    }
  }), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-742b2901"}!./src/scripts/components/page-home/template.html
// module id = 198
// module chunks = 0